var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarStroke = function SvgStarStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5001 11.4775L4.17103 13.18C3.43255 13.5576 2.94856 13.2134 3.08926 12.4154L3.72505 8.80949L1.03178 6.25575C0.434335 5.68925 0.621357 5.13512 1.44499 5.01871L5.16699 4.49261L6.83152 1.21182C7.20077 0.484043 7.80033 0.485828 8.16867 1.21182L9.8332 4.49261L13.5552 5.01871C14.3809 5.13541 14.5644 5.69064 13.9684 6.25575L11.2751 8.80949L11.9109 12.4154C12.052 13.2153 11.5658 13.5567 10.8292 13.18L7.5001 11.4775Z",
    stroke: "#F1C118",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-stroke.60bc99ce.svg";
export { ForwardRef as ReactComponent };